import { useEffect } from 'react';

const ADMIN_MAIN_SELECTOR = '.admin-layout-main';

/** Modal ichidagi scroll qilinishi mumkin bo‘lgan konteynerlar (touchmove ruxsat) */
const SCROLLABLE_MODAL_SELECTOR = [
  '.admin-modal-overlay',
  '.admin-imp-overlay',
  '[data-admin-modal-overlay="true"]',
  '.admin-ombor-overlay',
  '.admin-ombor-modal',
  '.admin-ombor-modal-scroll',
  '.admin-ombor-modal-body',
  '.admin-modal-panel',
  '.admin-expenses-modal-overlay',
  '.admin-expenses-modal',
  '.admin-expenses-supplier-table-wrap',
  '.admin-expenses-supplier-detail-scroll',
  '.admin-expenses-product-grid',
  '.ui-select__dropdown',
  '.tx-receipt-overlay',
  '.tx-receipt-modal',
  '.tx-receipt-body',
  '.tx-receipt-table-wrap',
].join(', ');

let lockCount = 0;
let savedBodyOverflow = '';
let savedBodyPaddingRight = '';
let savedHtmlOverflow = '';
let savedMainOverflow = '';
let savedMainTouchAction = '';
let savedMainPosition = '';
let savedMainTop = '';
let savedMainLeft = '';
let savedMainRight = '';
let savedMainWidth = '';
let savedMainScrollTop = 0;
let mainEl: HTMLElement | null = null;

function isIosLikeWebKit(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    /iPad|iPhone|iPod/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    || (typeof CSS !== 'undefined' && CSS.supports('(-webkit-touch-callout: none)'))
  );
}

/**
 * Modal ochilganda fon scrollini bloklaydi.
 * Admin panelda asosiy scroll `.admin-layout-main` da — body bilan birga qulflanadi.
 */
export function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;

    if (lockCount === 0) {
      const html = document.documentElement;
      mainEl = document.querySelector<HTMLElement>(ADMIN_MAIN_SELECTOR);

      savedBodyOverflow = document.body.style.overflow;
      savedBodyPaddingRight = document.body.style.paddingRight;
      savedHtmlOverflow = html.style.overflow;

      if (mainEl) {
        savedMainOverflow = mainEl.style.overflow;
        savedMainTouchAction = mainEl.style.touchAction;
        savedMainPosition = mainEl.style.position;
        savedMainTop = mainEl.style.top;
        savedMainLeft = mainEl.style.left;
        savedMainRight = mainEl.style.right;
        savedMainWidth = mainEl.style.width;
        savedMainScrollTop = mainEl.scrollTop;
        mainEl.style.overflow = 'hidden';
        mainEl.style.touchAction = 'none';
        if (isIosLikeWebKit()) {
          mainEl.style.position = 'fixed';
          mainEl.style.top = `-${savedMainScrollTop}px`;
          mainEl.style.left = '0';
          mainEl.style.right = '0';
          mainEl.style.width = '100%';
        }
      }

      const scrollbarW = window.innerWidth - html.clientWidth;
      document.body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';
      if (scrollbarW > 0) {
        const prevPad = parseFloat(savedBodyPaddingRight) || 0;
        document.body.style.paddingRight = `${prevPad + scrollbarW}px`;
      }
    }

    lockCount += 1;

    const preventTouchMove = (e: TouchEvent) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      if (target.closest(SCROLLABLE_MODAL_SELECTOR)) {
        return;
      }
      e.preventDefault();
    };

    document.addEventListener('touchmove', preventTouchMove, { passive: false });

    return () => {
      document.removeEventListener('touchmove', preventTouchMove);
      lockCount -= 1;
      if (lockCount <= 0) {
        lockCount = 0;
        document.body.style.overflow = savedBodyOverflow;
        document.body.style.paddingRight = savedBodyPaddingRight;
        document.documentElement.style.overflow = savedHtmlOverflow;
        if (mainEl) {
          mainEl.style.overflow = savedMainOverflow;
          mainEl.style.touchAction = savedMainTouchAction;
          mainEl.style.position = savedMainPosition;
          mainEl.style.top = savedMainTop;
          mainEl.style.left = savedMainLeft;
          mainEl.style.right = savedMainRight;
          mainEl.style.width = savedMainWidth;
          mainEl.scrollTop = savedMainScrollTop;
          mainEl = null;
        }
      }
    };
  }, [locked]);
}
